import { ColumnDef } from "@tanstack/react-table";
import { QueueSQLData } from "../../types/queueTypes";

// Transform function to ensure consistent data structure
export function transformQueueProjectData(
    data: QueueSQLData[]
): QueueSQLData[] {
    return data || [];
}

export const queueProjectColumns: ColumnDef<QueueSQLData>[] = [
    {
        accessorKey: "Project_Name",
        header: "Project Name",
        enableSorting: true,
        cell: ({ getValue }) => {
            const value = getValue() as string;
            return <span>{value || "N/A"}</span>;
        },
    },
    {
        accessorKey: "ISO",
        header: "ISO",
        enableSorting: true,
        cell: ({ getValue }) => {
            const value = getValue() as string;
            return <span>{value || "N/A"}</span>;
        },
    },
    {
        accessorKey: "Zone",
        header: "Zone",
        enableSorting: true,
        cell: ({ getValue }) => {
            const value = getValue() as string;
            return <span>{value || "N/A"}</span>;
        },
    },
    {
        accessorKey: "State",
        header: "State",
        enableSorting: true,
        cell: ({ getValue }) => {
            const value = getValue() as string;
            return <span>{value || "N/A"}</span>;
        },
    },
    {
        accessorKey: "County",
        header: "County",
        enableSorting: true,
        cell: ({ getValue }) => {
            const value = getValue() as string;
            return <span>{value || "N/A"}</span>;
        },
    },
    {
        accessorKey: "Fuel_Type",
        header: "Fuel Type",
        enableSorting: true,
        cell: ({ getValue }) => {
            const value = getValue() as string;
            return <span>{value || "N/A"}</span>;
        },
    },
    {
        accessorKey: "Size_MW",
        header: "Size (MW)",
        enableSorting: true,
        cell: ({ getValue }) => {
            const value = getValue() as number;
            return (
                <span>
                    {value ? value.toFixed(2) + " MW" : "N/A"}
                </span>
            );
        },
    },
    {
        accessorKey: "Study_Phase",
        header: "Study Phase",
        enableSorting: true,
        cell: ({ getValue }) => {
            const value = getValue() as string;
            return <span>{value || "N/A"}</span>;
        },
    },
    {
        accessorKey: "Queue_Cycle",
        header: "Queue Cycle",
        enableSorting: true,
        cell: ({ getValue }) => {
            const value = getValue() as string;
            return <span>{value || "N/A"}</span>;
        },
    },
];
